import { render, staticRenderFns } from "./InvoicePrize.vue?vue&type=template&id=d6e9de50&"
import script from "./InvoicePrize.vue?vue&type=script&lang=js&"
export * from "./InvoicePrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports